import { getTypes, getSearchTypes, getUtrRangeTypes, getPickleballRatingTypes } from '../api';

// load types from api
export function fetchTypes() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'CORE_UI:FETCH_TYPES' });
        try {
            const res = await getTypes(mainApi);
            const { data } = res;
            if (data.error) {
                dispatch({ type: 'CORE_UI:FETCH_TYPES_FAILURE' });
            } else {
                dispatch({ type: 'CORE_UI:FETCH_TYPES_SUCCESS', data });
            }
        } catch {
            dispatch({ type: 'CORE_UI:FETCH_TYPES_FAILURE' });
        }
    };
}

export function fetchSearchTypes() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'CORE_UI:FETCH_SEARCH_TYPES' });
        try {
            const res = await getSearchTypes(mainApi);
            const { data } = res;
            if (data.error) {
                dispatch({ type: 'CORE_UI:FETCH_SEARCH_TYPES_FAILURE' });
            } else {
                dispatch({ type: 'CORE_UI:FETCH_SEARCH_TYPES_SUCCESS', data });
            }
        } catch {
            dispatch({ type: 'CORE_UI:FETCH_SEARCH_TYPES_SUCCESS' });
        }
    };
}

export function fetchUtrRangeTypes() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'CORE_UI:FETCH_UTRRANGE_TYPES' });
        try {
            const res = await getUtrRangeTypes(mainApi);
            const { data } = res;
            if (data.error) {
                dispatch({ type: 'CORE_UI:FETCH_UTRRANGE_TYPES_FAILURE' });
            } else {
                dispatch({ type: 'CORE_UI:FETCH_UTRRANGE_TYPES_SUCCESS', data });
            }
        } catch {
            dispatch({ type: 'CORE_UI:FETCH_UTRRANGE_TYPES_SUCCESS' });
        }
    };
}

export function fetchPickleballRatingTypes() {
    return async (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'CORE_UI:FETCH_PICKLEBALL_RATING_TYPES' });
        try {
            const res = await getPickleballRatingTypes(mainApi);
            const { data } = res;
            if (data.error) {
                dispatch({ type: 'CORE_UI:FETCH_PICKLEBALL_RATING_TYPES_FAILURE' });
            } else {
                dispatch({ type: 'CORE_UI:FETCH_PICKLEBALL_RATING_TYPES_SUCCESS', data });
            }
        } catch {
            dispatch({ type: 'CORE_UI:FETCH_PICKLEBALL_RATING_SUCCESS' });
        }
    };
}
